/*
 * Side-effect module that replaces the worker auto-wiring of
 * `pdfjs-dist/webpack.mjs`, adapted for Safe Exam Browser's older engine
 * (issue #785): it wires the pdf.js worker to our local worker entry, which is
 * what lets us point the worker at the legacy build too.
 *
 * Importing this also loads pdf.mjs, which sets globalThis.pdfjsLib that
 * pdf_viewer.mjs reads on evaluation — so it must be imported before
 * pdf_viewer.mjs. Extensions are explicit because .mjs modules are resolved
 * fullySpecified by webpack.
 */
import { GlobalWorkerOptions } from "pdfjs-dist/legacy/build/pdf.mjs"

if (typeof window !== "undefined" && "Worker" in window) {
  const worker = new Worker(
    new URL("./pdf.worker.mjs", import.meta.url),
    { type: "module" }
  )

  // A worker that fails to load or parse fires `error` and pdf.js then falls
  // back to running the worker code on the main thread — silently. In Safe Exam
  // Browser, where there is no console, that fallback hides the real cause, so
  // record it for the on-screen error panel (see diagnostics.ts). The store is
  // addressed by its global name because this .mjs module is resolved
  // fullySpecified and cannot import the .ts helper.
  worker.addEventListener("error", (event) => {
    const store = (globalThis.__pdfViewerDiagnostics ||= [])

    if (store.length < 20) {
      store.push(
        `pdf.js worker failed to start: ${event.message || "(no message)"} ` +
        `@ ${event.filename || "?"}:${event.lineno || 0}`
      )
    }
  })

  GlobalWorkerOptions.workerPort = worker
}
